import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=3d2c6320&"
import script from "./UserActivities.vue?vue&type=script&lang=js&"
export * from "./UserActivities.vue?vue&type=script&lang=js&"
import style0 from "./UserActivities.vue?vue&type=style&index=0&id=3d2c6320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports